import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-desglose-confeccion-hist-etiquetado',
    templateUrl: './desglose-confeccion.component.html'
})
export class DesgloseConfeccionHistEtiquetadoComponent {

    @Input() confecciones;

    constructor(
        private readonly _translate: TranslateService
    ) { }

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }
}